import EmergencyRFV from '@/assets/SVG/EmergencyRFV';

import { reasonForVisitStyles } from './ReasonForVisit.styles';

export const Emergency = () => (
	<div
		style={
			{
				...reasonForVisitStyles.reasonForVisitIcon,
				...reasonForVisitStyles.reasonForVisitIconEmergency,
			} as React.CSSProperties
		}
	>
		<EmergencyRFV />
	</div>
);
